<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import { FETCH_CITIES } from '../store/modules/cities/actions'

export default {
  name: 'Test',
  data () {
    return {
      msg: 'Shity Shit'
    }
  },
  // map this.cities to store.state.cities
  computed: {
    ...mapGetters({
      cityList: 'city/items',
      isLoading: 'city/isLoading'
    })
  },
  mounted () {
    this.fetchCities()
  },
  methods: {
    fetchCities () {
      this.$store.dispatch('city/FETCH_CITIES')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/Test.vue